export default {
	orders: {
		loading: "Caricamento degli ordini in corso...",
		noOrders: "Ancora nessun ordine presente",
		states: {
			ordered: "Ordinato",
			delivered: "Consegnato",
			paid: "Concluso",
			inProduction: "In produzione",
			produced: "In spedizione",
			invoiced: "Fattura inviata",
			cancelled: "Annullato",
			creditOverdrawn: "Limite di credito superato",
			unknown: "Sconosciuto",
			dueDateLabel: "Data di consegna franco fabbrica",
		},
		kommission: {
			placeholder: "Qui può inserire il suo numero d'ordine",
			placeholderShort: "Inserire …",
			label: "Numero d'ordine",
			yourNumberLabel: "Il suo numero d'ordine:",
			yourNumberShortLabel: "Il suo n. d'ordine",
		},
		orderIdLabel: "Ordine Blexon",
		carrierLabel: "Trasportatore",
		trackingLabel: "Tracciamento della spedizione",
		orderConfirmation: {
			downloadTooltip: "Scarica la conferma d'ordine come documento PDF",
			label: "Conferma d'ordine",
			fileName: "Conferma d'ordine {orderId}.pdf",
		},
		invoice: {
			downloadTooltip: "Scarica la fattura come documento PDF",
			label: "Fattura",
			fileName: "Fattura per l'ordine {orderId}.pdf",
		},
		prepayInvoice: {
			downloadTooltip: "Scarica la fattura di acconto come documento PDF",
			label: "Fattura di acconto",
			fileName: "Fattura di acconto {invoiceId}.pdf",
		},
		pageTitle: "Archivio ordini",
		loadingArchive: "Caricamento dell'archivio ordini in corso …",
		searchPlaceholder: "Cerca per n. ordine, il suo n. ordine o id articolo …",
		filterAriaLabel: "Filtra per tipo",
		filterAll: "Tutti",
		filterOrders: "Ordini",
		filterCredits: "Note di credito",
		noEntriesFound: "Nessuna voce trovata",
		noCreditsYet: "Ancora nessuna nota di credito presente",
		adjustSearchHint: "Adatti la ricerca o il filtro.",
		creditPillTooltip:
			"Totale delle sue note di credito aperte. Verrà conteggiato automaticamente sulla prossima fattura.",
		availableCredit: "Credito disponibile",
		thumbsTooltip: "Articoli di questo ordine",
		articleCountSuffix: "articoli",
		detailsButton: "Dettagli",
		orderTypeTag: "Ordine",
		orderTitle: "Ordine {number} del {date}",
		certificatesSuffix: " / Certificati",
		creditNote: {
			typeTag: "Nota di credito",
			unassignedChip: "Senza riferimento a un ordine",
			stateRefunded: "Rimborsato",
			stateSettled: "Conteggiato",
			stateOpen: "Aperto",
			unassignedNote:
				"Questa nota di credito non è collegata a nessun ordine e verrà conteggiata sulla prossima fattura.",
			settledNextInvoiceNote: "Verrà conteggiato sulla prossima fattura.",
			numberLabel: "N. nota di credito",
			dateLabel: "Data",
			referenceLabel: "Riferimento",
			referenceOrder: "Ordine {orderId}",
			noReference: "Nessun ordine",
			settledOnLabel: "Conteggiato su",
			invoiceReference: "Fattura {invoiceId}",
			downloadTooltip: "Scarica la nota di credito come documento PDF",
			downloadButton: "Nota di credito",
			fileName: "Nota di credito {creditNoteId}.pdf",
		},
		details: "Dettagli",
		detailsWithCertificates: "Dettagli / Certificati",
		cancellation: {
			inReview: "Annullamento in verifica",
			show: "Visualizza annullamento",
			completed: "Annullamento concluso",
			processing: "Annullamento in elaborazione",
			cancelButton: "Annulla",
			orderCancelledSuccess: "L'ordine è stato annullato con successo.",
			orderAlreadyProcessed: "Nel frattempo l'ordine è stato elaborato.",
			cancelFailed: "Non è stato possibile annullare l'ordine.",
		},
		changeDeliveryAddress: "Modifica indirizzo di consegna",
		changeInvoiceAddress: "Modifica indirizzo di fatturazione",
		loadMore: {
			tooltip: "Carica altri ordini.",
			button: "Carica altri",
		},
		confirmCancellationDialog: {
			title: "Confermare l'annullamento",
			text: "L'elaborazione di questo ordine non è ancora iniziata.",
			text2: "In questo caso l'annullamento è possibile gratuitamente. Tuttavia può essere annullato solo l'intero ordine. Se necessario, l'ordine dovrà essere effettuato nuovamente.",
			cancelButton: "Annulla",
			confirmButton: "Annulla ordine",
		},
		messages: {
			kommissionSaved: "Il numero d'ordine è stato salvato.",
			kommissionSaveError: "Non è stato possibile salvare il numero d'ordine.",
		},
	},
	orderDetail: {
		backToOrders: "Archivio ordini",
		orderHeading: "Ordine {orderId}",
		certificatesAvailable: {
			title: "Certificati disponibili",
			subtitle: "Scarica i certificati materiale 3.1 per questo ordine.",
			button: "Certificato 3.1 · Articolo {articleId}",
		},
		orderDataTitle: "Dati dell'ordine",
		orderReceivedLabel: "Ricezione dell'ordine",
		yourOrderNumberShortLabel: "Il suo numero d'ordine",
		noOrderNumberShort: "nessuna indicazione",
		expectedDeliveryDateShortLabel: "Data di consegna prevista (franco fabbrica)",
		expectedCompletionShortLabel: "Completamento previsto",
		trackingLabelShort: "Tracciamento della spedizione",
		invoiceAddressCardTitle: "Indirizzo di fatturazione",
		positionsCardTitle: "Posizioni",
		tableShort: {
			posAbbr: "Pos.",
			totalAbbr: "Totale ({currency})",
		},
		titleLabel: "Conferma dell'ordine {orderId}",
		orderDateLabel: "Ricezione dell'ordine:",
		yourOrderNumberLabel: "Il suo numero d'ordine:",
		noOrderNumber: "nessuna indicazione (può modificarla nell'archivio ordini)",
		expectedDeliveryDateLabel: "Data di consegna prevista (franco fabbrica):",
		trackingEmailInfo:
			"Al termine dell'ordine, riceverà un'e-mail con un link per il tracciamento della spedizione.",
		expectedCompletionLabel: "Completamento previsto:",
		pickupImportantLabel: "Importante:",
		pickupEmailInfo:
			"Riceverà un'e-mail non appena il suo ordine sarà pronto per il ritiro. Il ritiro sarà possibile solo dopo aver ricevuto questa e-mail.",
		invoiceAddressLabel: "Indirizzo di fatturazione:",
		pickupAddressLabel: "Indirizzo di ritiro",
		deliveryAddressLabel: "Indirizzo di consegna",
		pickupAddressName: "Ritiro",
		priceModel: {
			standard: "(Consegna rapida)",
			slow: "(Consegna a prezzo ottimizzato)",
			express: "(Consegna express)",
		},
		table: {
			position: "Posizione",
			quantity: "Quantità",
			preview: "Anteprima",
			description: "Descrizione",
			pricePerUnit: "Prezzo/pz",
			totalPrice: "Prezzo totale ({currency})",
		},
		engraving: "Incisione",
		deburring: "Sbavatura:",
		preCoated: "preverniciato",
		certificateLink: "Certificato 3.1",
		vatLabel: "IVA ({rate}%)",
		totalLabel: "Totale",
		certificateErrorDialog: {
			title: "Impossibile caricare il certificato",
			text: "Al momento non è possibile caricare il certificato. Il servizio sembra non disponibile.",
			text2: "La preghiamo di contattare il nostro helpdesk.",
			closeButton: "Chiudi",
		},
	},
	ticket: {
		tooltip: "Apre la finestra di dialogo per la compilazione di un reclamo relativo a questo ordine.",
		deadlinePassedTooltip: "Il termine per un reclamo è scaduto. Si rivolga al nostro helpdesk.",
		createButton: "Registra reclamo",
		showButton: "Visualizza reclamo",
	},
	editTicketPosition: {
		blexonIdLabel: "Id Blexon:",
		materialLabel: "Materiale:",
		preCoated: "preverniciato",
		engraving: "Incisione",
		introText:
			"Per poter elaborare il suo reclamo in modo rapido e semplice, abbiamo bisogno di alcune indicazioni per ogni posizione.",
		complainTypeQuestion: "Di che tipo è il suo reclamo?",
		selectPlaceholder: "La preghiamo di selezionare",
		uploadPhotosQuestion: "Carichi le foto che mostrano il reclamo nel modo più chiaro possibile",
		deleteImageTooltip: "Elimina immagine",
		minOneImageHint: "Deve essere caricata almeno un'immagine.",
		affectedPartsQuestion: "Quanti pezzi di questa posizione sono interessati?",
		allButton: "Tutti",
		partsCountLabel: "Numero di pezzi",
		complaintDescriptionQuestion: "Cosa desidera reclamare?",
		complaintDescriptionLabel: "Reclamo",
		expectationQuestion: "Cosa si aspetta da noi?",
		expectationLabel: "Aspettativa",
		messages: {
			requiredField: "Deve essere indicato.",
			enterValue: "Indicare un valore",
			minimumOne: "Almeno 1",
			maximum: "Massimo {max}",
			maxImagesExceeded: "Può caricare al massimo 10 immagini.",
			imageUploadError:
				"Non è possibile leggere l'immagine. La preghiamo di utilizzare un'immagine in formato jpg, png o gif. In caso di problemi, contatti info@blexon.com.",
		},
	},
	requestCancellation: {
		orderNotFound: "Non è stato possibile trovare l'ordine.",
		titleLabel: "Richiesta di annullamento per l'ordine #{orderId}",
		alreadyProcessedWarning: "Purtroppo l'elaborazione dell'ordine è già iniziata.",
		introText:
			"Questo ordine è già in fase di elaborazione. Tuttavia è comunque possibile richiedere un annullamento.",
		introText2:
			"Chiariremo i costi già sostenuti e la contatteremo via e-mail. Deciderà quindi quali posizioni dell'ordine desidera annullare definitivamente.",
		feeNoticePart1:
			"Anche se, dopo il chiarimento dei costi, si rinuncia all'annullamento, è dovuta una tassa di elaborazione di",
		feeNoticePart2: "non appena richiede un annullamento.",
		selectArticlesText: "Selezioni gli articoli da annullare:",
		table: {
			position: "Posizione",
			quantity: "Quantità",
			preview: "Anteprima",
			description: "Descrizione",
			pricePerUnit: "Prezzo / pz",
			priceTotal: "Prezzo totale",
		},
		blexonIdLabel: "Id Blexon:",
		acceptCostsLabel:
			"Accetto la tassa di elaborazione forfettaria di {currency} {fixCost}.-, dovuta al momento della richiesta di annullamento.",
		forceCancellationLabel:
			"OPZIONALE! Desidero annullare definitivamente le posizioni selezionate, indipendentemente dai costi sostenuti. Confermo di assumermi tutti i costi di annullamento per le posizioni e la tassa forfettaria di annullamento e di rinunciare ai pezzi.",
		contactInfoText1: "La informeremo in merito a questo annullamento all'indirizzo",
		contactInfoText2:
			"Se desidera essere contattato a un altro indirizzo e-mail, può indicarlo qui:",
		altContactEmailLabel: "Indirizzo e-mail alternativo",
		cancelButton: "Annulla",
		forceCancelButton: "Annulla definitivamente",
		requestCancelButton: "Richiedi annullamento",
		altContactButton: {
			useStandard: "Utilizza i dati di contatto standard",
			useAlternative: "Utilizza dati di contatto alternativi",
		},
		messages: {
			fixCostLoadError: "Non è stato possibile caricare la tassa forfettaria di annullamento.",
			positionsLoadError: "Non è stato possibile caricare le posizioni dell'ordine.",
			cancellationRequested: "L'annullamento è stato richiesto.",
			cancellationRequestError: "Non è stato possibile richiedere l'annullamento.",
			requiredField: "Deve essere indicato.",
			invalidEmail: "E-mail non valida.",
		},
	},
	cancellationConfirmation: {
		requestNotFound: "Non è stato possibile trovare la richiesta di annullamento.",
		alreadyProcessed: "Questa richiesta di annullamento è già stata elaborata.",
		titleLabel: "Confermare l'annullamento per l'ordine #{orderId}",
		introText: "Ha richiesto di annullare determinate posizioni di questo ordine.",
		introText2:
			"I costi per l'annullamento sono elencati di seguito per posizione. Può selezionare le posizioni che desidera annullare. I costi verranno adeguati di conseguenza. Le posizioni non annullate continueranno a essere elaborate normalmente. La tassa forfettaria di annullamento per i chiarimenti già effettuati in relazione all'annullamento è comunque dovuta ed è inclusa nei costi.",
		table: {
			articleId: "Id articolo",
			position: "Posizione",
			preview: "Anteprima",
			description: "Descrizione",
			cancellationCost: "Costi di annullamento",
		},
		flatFeeLabel: "Tassa forfettaria di annullamento",
		totalLabel: "Totale",
		backButton: "Indietro",
		doNotCancelButton: "Non annullare",
		cancelSelectedButton: "Annulla le posizioni selezionate",
		messages: {
			loadCancellationError: "Non è stato possibile caricare i dati di annullamento.",
			loadOrderError: "Non è stato possibile caricare i dati dell'ordine.",
			confirmError: "Non è stato possibile confermare l'annullamento.",
		},
	},
	choosePosition: {
		introText: "Selezioni tutte le posizioni interessate da questa segnalazione.",
		table: {
			position: "Posizione",
			image: "Immagine",
			description: "Descrizione",
			quantity: "Quantità",
			unitPrice: "Prezzo unitario",
			total: "Totale",
		},
		blexonIdLabel: "Id Blexon:",
		materialLabel: "Materiale:",
		preCoated: "preverniciato",
		engraving: "Incisione",
	},
	createTicket: {
		titleLabel: "Reclamo per l'ordine {orderId}",
		stepper: {
			choosePositions: "Selezionare le posizioni",
			positionAbbrev: "Pos",
			position: "Posizione",
			contactData: "Dati di contatto",
			confirmation: "Conferma",
		},
		emailNoticePart1: "Le invieremo un'e-mail a",
		emailNoticePart2:
			", non appena lo stato di questo reclamo cambia. In caso di domande, la chiameremo al",
		emailNoticePart3: ".",
		altContactPrompt:
			"Se desidera essere contattato diversamente per l'elaborazione di questo reclamo, può indicare qui dati di contatto alternativi:",
		altContactEmailLabel: "Indirizzo e-mail alternativo",
		altContactPhoneLabel: "Numero di telefono alternativo",
		altContactButton: {
			useStandard: "Utilizza i dati di contatto standard",
			useAlternative: "Utilizza dati di contatto alternativi",
		},
		missingInfoText: "La preghiamo di completare le indicazioni mancanti per creare il ticket.",
		table: {
			position: "Posizione",
			image: "Immagine",
			blexonId: "Id Blexon",
			complainedCount: "# Reclamati",
			name: "Nome",
			complaint: "Reclamo",
			expectation: "Aspettativa",
		},
		correspondenceToLabel: "Corrispondenza a:",
		replacementDelivery: "Consegna sostitutiva",
		backButton: "Indietro",
		nextButton: "Avanti",
		finishButton: "Concludi",
		ticketBlockedHint:
			"Questo reclamo è già stato elaborato. Per ulteriore assistenza contatti info@blexon.com.",
		leaveDialog: {
			title: "Avviso di perdita dati",
			text: "Le modifiche verranno annullate se abbandona la pagina.",
		},
		messages: {
			requiredField: "Deve essere indicato.",
			invalidEmail: "E-mail non valida.",
			saveSuccess: "Il reclamo è stato salvato con successo.",
			saveError: "Errore durante il salvataggio. La preghiamo di contattare info@blexon.com.",
			orderNotFound: "Impossibile creare il ticket. Ordine non trovato.",
		},
	},
};
